import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/unsubscribe")({
  component: lazyRouteComponent(() => import("@/pages/Unsubscribe")),
});
